import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BlogImage from "../../assest/image/Portfolio/Social/Social (1).jpg";
import "../../assest/css/Blog.css";
import Footer from "../Footer/Footer";
import { FaSearch } from "react-icons/fa";
import Apiurl from "../environments/Apiurl";
import axios from "axios";

const Blog = () => {
  const navigate = useNavigate();
  const [getData, SetGetData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/blog/blog-card`);
      SetGetData(response.data.blogs || []);
      console.log("Get Blog Cards Data", response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const categories = [
    "All",
    ...new Set(getData.map((blog) => blog.category).filter(Boolean)),
  ];

  // States
  const [activeCategory, setActiveCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTag, setActiveTag] = useState(""); // NEW

  // TAGS LIST
  const tagsList = [
    "Trending Courses",
    "Internship Programs",
    "Career Growth & Training",
    "Offers & Updates",
  ];

  // FILTER LOGIC
  const filteredBlogs = getData
    .filter(
      (blog) => activeCategory === "All" || blog.category === activeCategory
    )
    .filter((blog) => (activeTag ? blog.category === activeTag : true))
    .filter(
      (blog) =>
        blog.blog_title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        blog.blog_para.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const cleanImageUrl = (url) => {
    if (!url) return BlogImage;
    return url
      .replace(/^\/+/, "")
      .replace(/uploads/i, "uploads")
      .replace(/\/uploads\/+uploads\//i, "/uploads/")
      .replace(/^(.*\/)uploads\//i, "$1uploads/");
  };

  const handleSearch = () => {
    console.log("Searching for:", searchTerm);
  };

  return (
    <HelmetProvider>
      <div className="container-fluid p-0 about-container">
        <Helmet>
          <title>Blogs - Aalan TechSoft | Software Insights</title>
          <meta
            name="description"
            content="Explore the latest articles on tech, design, and innovation at Aalan TechSoft."
          />
        </Helmet>

        {/* Hero Section */}
        <div className="Blog-hero">
          <div className="about-content text-center">
            <div className="hero-title-container">
              <span className="badge-title">Blog</span>
              <h1 className="text-white fw-bold">Insights & Updates</h1>
              <p className="text-light">
                Latest articles on tech, design, and innovation.
              </p>
            </div>
          </div>
        </div>

        {/* Blog Section */}
        <section className="blog-section py-5">
          <Container>
            <Row className="g-4" data-aos="fade-up">
              {/* Search */}
              <Col lg={4} md={6}>
                <div className="shadow p-3 rounded-4 bg-white h-100">
                  <h5
                    className="mb-3 fw-bold"
                    style={{
                      borderLeft: "4px solid #85bf39",
                      paddingLeft: "10px",
                    }}
                  >
                    Search
                  </h5>

                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="rounded-start-pill border-end-0 shadow-sm"
                      style={{ padding: "10px 15px", fontSize: "15px" }}
                    />
                    <Button
                      className="rounded-end-pill px-4 d-flex align-items-center justify-content-center"
                      style={{ backgroundColor: "#85bf39", border: "none" }}
                      onClick={handleSearch}
                    >
                      <FaSearch />
                    </Button>
                  </InputGroup>
                </div>
              </Col>

              {/* Categories */}
              <Col lg={4} md={6}>
                <div className="shadow p-4 rounded-4 bg-white h-100">
                  <h5
                    className="mb-3 fw-bold"
                    style={{
                      borderLeft: "4px solid #85bf39",
                      paddingLeft: "10px",
                    }}
                  >
                    Categories
                  </h5>

                  <Form.Select
                    className="form-select rounded-pill bg-light border-0 shadow-sm"
                    style={{ padding: "10px 15px", fontSize: "15px" }}
                    value={activeCategory}
                    onChange={(e) => {
                      setActiveCategory(e.target.value);
                      setActiveTag(""); // reset tag when category changes
                    }}
                  >

                    {categories.map((cat) => (
                      <option key={cat} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </Col>

              {/* Tags WITH FILTER LOGIC */}
              <Col lg={4}>
                <div className="shadow p-3 rounded-4 bg-white h-100 d-none d-lg-block">
                  <h5
                    className="mb-3 fw-bold"
                    style={{
                      borderLeft: "4px solid #85bf39",
                      paddingLeft: "10px",
                    }}
                  >
                    Tags
                  </h5>

                  <div className="d-flex flex-wrap gap-2">
                    {tagsList.map((tag, index) => (
                      <Button
                        key={index}
                        className="rounded-pill px-3 py-1 small"
                        style={{
                          backgroundColor:
                            activeTag === tag ? "#85bf39" : "transparent",
                          border:
                            activeTag === tag
                              ? "2px solid #85bf39"
                              : "2px solid #85bf39",
                          color: activeTag === tag ? "#fff" : "#000",
                          fontSize: "13px",
                        }}
                        onClick={() => {
                          setActiveTag(tag);
                          setActiveCategory("All"); // reset dropdown filter
                        }}
                      >
                        {tag}
                      </Button>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>

            {/* Blog Cards */}
            <Row className="my-5">
              <Col lg={12} md={12}>
                <Row>
                  {filteredBlogs.length > 0 ? (
                    filteredBlogs.map((item, index) => (
                      <Col
                        xs={12}
                        lg={4}
                        md={6}
                        key={item._id || index}
                        className="mb-4"
                      >
                        <Card
                          className="shadow-sm border-0 h-100"
                          data-aos="fade-up"
                          data-aos-delay={index * 100}
                        >
                          <Card.Img
                            variant="top"
                            src={cleanImageUrl(item.cover_image)}
                            alt={item.blog_title}
                            style={{
                              height: "200px",
                              objectFit: "cover",
                              borderTopRightRadius: "10px",
                              borderTopLeftRadius: "10px",
                            }}
                            onError={(e) => {
                              e.target.src = BlogImage;
                            }}
                          />

                          <Card.Body className="d-flex flex-column">
                            {/* Top Row */}
                            <div className="d-flex justify-content-between mb-2">
                              <span className="badge badge-title text-white">
                                {item.category}
                              </span>

                              <small className="text-muted">
                                {item.post_date}
                              </small>
                            </div>

                            {/* Title */}
                            <Card.Title className="fw-bold mt-3">
                              {item.blog_title}
                            </Card.Title>

                            {/* Description */}
                            <Card.Text
                              className="text-dark"
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: "2",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                minHeight: "48px",
                              }}
                            >
                              {item.blog_para}
                            </Card.Text>

                            <div className="mt-auto">
                              <span
                                className="fw-bold"
                                style={{
                                  cursor: "pointer",
                                  color: "#85bf39",
                                  fontSize: "16px",
                                }}
                                onClick={() =>
                                  navigate(`/blogs/${item._id}`)
                                }
                              >
                                Read More
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))
                  ) : (
                    <Col xs={12}>
                      <p className="text-muted text-center">No blogs found.</p>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Blog;